import React from 'react'
import { ReactComponent as FriendsIcon } from '../img/ic_amigos.svg';
import { Translate } from '../language'
import { ReactComponent as CloseIcon } from '../img/ic_cerrar.svg';
import Button from '../utils/components/Button/Button';

const ModalSelectPrivacy = ({ displayModal, setPrivacy, privacy, closeModal, isMark }) => {

    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }
    const close = (e) => {
        e.stopPropagation()
        closeModal(e)
    }
    return (
        <div
            className={"modal modal-tag-friend"}
            onClick={close}
            style={divStyle} >
            <div
                className="modal-content modal-content-tag-friend pb-0"
                onClick={e => e.stopPropagation()}
            >
                <div onClick={close} className="close-modal">
                    <CloseIcon className="cls-1 white-svg" height="18" width="18" />
                </div>
                <div className="select-privacy-new-post">
                    <div className="mt-5 text-fz-1-5 text-white"> {Translate('privacyMessageTittleNewPost', 'es')}</div>
                    <div>{Translate('privacyMessageDescriptionNewPost', 'es')}</div>
                    <div className="select-privacy-new-album mb-0">
                        <Button text={Translate('public', 'es')} active={privacy === 0}  onClick={() => setPrivacy(0)}></Button>
                        <Button text={Translate('myPrivate', 'es')} active={privacy === 1} onClick={() => setPrivacy(1)}></Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ModalSelectPrivacy;